import classes from "./avatar.module.css";
import User from '@/assets/svg/icons/user.svg';
import Indicator from "./indicator";
import SafeImage from "@/components/common/safe_image";
import CustomSVG from "../svg";

const AVATAR_DIMENSIONS = {
    "2xs": 16,
    xs: 24,
    sm: 32,
    md: 40,
    lg: 48,
    xl: 56,
    "2xl": 64,
};

const PROFILE_AVATAR_DIMENSIONS = {
    xs: 32,
    sm: 48,
    md: 96,
    lg: 160,
};

function getAvatarDimension(size, profile) {
    if (profile) return PROFILE_AVATAR_DIMENSIONS[size] || AVATAR_DIMENSIONS[size] || AVATAR_DIMENSIONS.md;
    return AVATAR_DIMENSIONS[size] || AVATAR_DIMENSIONS.md;
}

function normalizeAvatarUrl(url) {
    if (typeof url !== "string") return url;

    const trimmedUrl = url.trim();
    if (!trimmedUrl) return trimmedUrl;
    if (trimmedUrl.includes("?br=")) return trimmedUrl;

    const match = trimmedUrl.match(/^(.*\/uploads\/.*\/)([^/?#]+?)-(640|1080|1920)w\.webp([?#].*)?$/i);
    if (!match) return trimmedUrl;

    const [, prefix, fileName, bestRes, suffix = ""] = match;
    const joiner = suffix.startsWith("?") ? "&" : "?";

    return `${prefix}${fileName}.webp${suffix}${joiner}br=${bestRes}`;
}


export default function Avatar({size, url, indicator, text, button=false, profile, white, border="primary", ...props}) {
    let svg_size = 24;
    let text_size = "text-md-medium";
    const avatarDimension = getAvatarDimension(size, profile);
    const normalizedUrl = normalizeAvatarUrl(url);

    switch(size) {
        case "xs":
            text_size = "text-xs-medium";
            svg_size = 16;
            break;
        case "sm":
            if(profile) {
                text_size = "display-sm-medium";
                svg_size = 24;
            } else {
                text_size = "text-sm-medium";
                svg_size = 20;
            }
            break;
        case "md":
            if(profile) {
                text_size = "display-md-medium";
                svg_size = 48;
            } else {
                text_size = "text-md-medium";
                svg_size = 24;
            }
            break;
        case "lg":
            if(profile) {
                text_size = "display-xl-medium";
                svg_size = 80;
            } else {
                text_size = "text-lg-medium";
                svg_size = 28;
            }
            break;
        case "xl":
            text_size = "text-xl-medium";
            svg_size = 32;
            break;
        case "2xl":
            text_size = "display-xs-medium";
            svg_size = 32;
            break;
        default:
            text_size = "text-md-medium";
            svg_size = 24;
            break;
    }

    let mainContent;
    let border_width = 0;
    if(normalizedUrl) {
        mainContent = <SafeImage src={normalizedUrl} height={avatarDimension} width={avatarDimension} sizes={`${avatarDimension}px`} alt="user_image" style={{borderRadius: "50%", width: '100%', height: '100%', objectFit: "cover" }} />
    } else if(text) {
        mainContent = <div className={`${classes.text} ${text_size} color-primary-500`}>{text}</div>
        border_width = 2;
    } else {
        mainContent = (white 
            ? <CustomSVG SvgFunction={User} className="stroke-gray-800 circle-stroke-gray-800" height={svg_size} width={svg_size} />
            : <CustomSVG SvgFunction={User} className="stroke-primary-500 circle-stroke-primary-500 fill-primary-400 circle-primary-400" height={svg_size} width={svg_size} />
        ) 
        border_width = 1;
    }

    let temp_return = <div className={`${props.className} ${classes.avatar} ${classes[`size-${size}`]} ${profile ? classes.profile : ''} ${white ? classes.white : ''} ${(border && !profile) ? `${classes[`border-${border}`]}` : ""} ${classes[`border-${border_width}`]}`}>
        {mainContent}
        {indicator && <div className={classes.indicator}>
            <Indicator type={indicator} size={size} />
        </div>}
    </div>

    if(button) temp_return = <button className={classes["avatar-button"]} {...props} >{temp_return}</button>

    return temp_return;
}